module.exports = __webpack_public_path__ + "static/media/Momento MockUp Classic 2in1.53f5b05b.jpg";